import { styled } from "@mui/material/styles";
import { Alert } from "@mui/material";

const StyledAlert = styled(Alert)`
  &.MuiAlert-root,
  &.MuiAlert-filled,
  &.MuiAlert-outlined {
    border-radius: 8px;
    color: ${({ theme }) => theme.palette.common.black};
    font-size: ${({ theme }) => theme.typography.h3.fontSize};
    line-height: ${({ theme }) => theme.typography.h3.lineHeight};
    font-weight: 300;
    display: flex;
    align-items: center;
    min-height: 52px;
    padding: 12px 16px;
    box-sizing: border-box;
    user-select: none;
  }

  &.MuiAlert-standardSuccess,
  &.MuiAlert-outlinedSuccess,
  &.MuiAlert-filledSuccess {
    background-color: ${({ theme }) => theme.palette.green.light};
  }

  &.MuiAlert-outlinedSuccess {
    border: 1px solid ${({ theme }) => theme.palette.green.main};
  }

  &.MuiAlert-standardError,
  &.MuiAlert-outlinedError,
  &.MuiAlert-filledError {
    background-color: ${({ theme }) => theme.palette.red.light};
  }

  &.MuiAlert-outlinedError {
    border: 1px solid ${({ theme }) => theme.palette.red.main};
  }

  &.MuiAlert-standardInfo,
  &.MuiAlert-outlinedInfo,
  &.MuiAlert-filledInfo {
    background-color: ${({ theme }) => theme.palette.blue.light};
  }

  &.MuiAlert-outlinedInfo {
    border: 1px solid ${({ theme }) => theme.palette.blue.main};
  }

  &.MuiAlert-standardWarning,
  &.MuiAlert-outlinedWarning,
  &.MuiAlert-filledWarning {
    background-color: ${({ theme }) => theme.palette.yellow.light};
  }

  &.MuiAlert-outlinedWarning {
    border: 1px solid ${({ theme }) => theme.palette.yellow.main};
  }

  & .MuiAlert-icon {
    flex-shrink: 0;
    width: 20px;
    height: 20px;
    padding: 0;
    margin-bottom: 2px;

    & svg {
      width: 100%;
    }
  }

  & .MuiAlert-message {
    padding: 0;
  }

  & .MuiAlert-action {
    padding-top: 0;
    margin-right: 0;
  }
`;


const StyledAlertToolsContainer = styled("div")`
  width: max-content;
  display: flex;
  align-items: center;
  gap: 16px;
`;

const StyledLoginError = styled("div")`
  color: ${({ theme }) => theme.palette.red.main};
  font-size: ${({ theme }) => theme.typography.bodyL?.fontSize};
  font-family: ${({ theme }) => theme.typography.fontFamily};
`;

export { StyledAlert, StyledAlertToolsContainer, StyledLoginError };
